
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { affiliate } from '../apis/affiliate';
import { onMounted, ref } from 'vue';
import CardWithdraw, { WithdrawDetail } from '../components/card/CardWithdraw.vue';
import { main_wallet } from '../apis/main_wallet';
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import { useWebStore } from '../stores/web';

export default {
	name: 'AffiliateLink',
	components: {
		CardWithdraw,
		IftaLabel,
		Button,
		Toast,
	},
	setup() {
		const auth = useAuthStore();
		const { profile } = storeToRefs(auth);

		const web = useWebStore();
		const {webPermission} = storeToRefs(web);

		const toast = useToast();

		onMounted(() => {
			auth.hydrate();
			web.hydrate()
			handleWalletAffiliate();
			handleLinkAffiliate();
			walletAffiliate.value.active = webPermission.value?.isOther.isAffiliate || true;
		});

		const affiliateLink = ref({
			loading: false,
			link: '',
		})

		const walletAffiliate = ref<WithdrawDetail>({
			label: 'แนะนำเพื่อน',
			amount: profile.value?.walletAffiliate || 0,
			btnLabel: 'รับ',
			btnDisabled: true,
			btnLoading: false,
			btnTooltip: '',
			details: [],
			loading: false,
			active: false,
		});


		const handleLinkAffiliate = async () => {
			affiliateLink.value.loading = true;
			try {
				const resp = await affiliate.linkAffiliate({ url: window.location.origin });

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				const url = new URL(resp.result.link);

				affiliateLink.value.link = window.location.origin + url.search;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				affiliateLink.value.loading = false;
			}
		};

		const handleAffiliateWithdraw = async () => {
			walletAffiliate.value.loading = true;

			try {
				const respPreviewTakeAffiliate = await affiliate.previewTakeAffiliateCredit();

				if (respPreviewTakeAffiliate.code !== '0') throw new Error(respPreviewTakeAffiliate.message);

				const respDepositAffiliate = await main_wallet.depositAffiliate();

				if (respDepositAffiliate.code !== '0') throw new Error(respDepositAffiliate.message);

				await handleWalletAffiliate();

				toast.add({ severity: 'success', summary: respDepositAffiliate.message, detail: 'รับยอดแนะนำเพื่อนสำเร็จ', life: 3000 });
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletAffiliate.value.loading = false;
			}
		};

		const handleWithdraw = async (walletName: string) => {
			switch (walletName) {
				case 'walletAffiliate':
					await handleAffiliateWithdraw();
					break;
			}
		};

		const handleWalletAffiliate = async () => {
			walletAffiliate.value.loading = true;
			try {
				const resp = await main_wallet.checkConditionAddCreditSpecialType();

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result;

				walletAffiliate.value.btnTooltip = result?.message || '';

				walletAffiliate.value.btnDisabled = result.isDisableBtn;

				await auth.fetchData();

				walletAffiliate.value.amount = profile.value?.walletAffiliate || 0;

				if (walletAffiliate.value.amount < 1) {
					walletAffiliate.value.btnTooltip = 'ยอดเงินไม่ถึงกำหนด';
					walletAffiliate.value.btnDisabled = true;
				}
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletAffiliate.value.loading = false;
			}
		};

		const copyToClipboard = async () => {
			try {
				await navigator.clipboard.writeText(affiliateLink.value.link);
				toast.add({ severity: 'info', summary: 'คัดลอกลิงก์แนะนำเพื่อน', detail: 'สำเร็จ!', life: 3000 });
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		};

		return {
			profile,
			affiliateLink,
			walletAffiliate,
			handleWithdraw,
			copyToClipboard,
		};
	},
};
